/**
 * Formate GATSBY_RELEASE_VERSION complet (horodatage inclus, une valeur par
 * build, ex. "20261008T101500_1.42.1") pour le tag DataDog `version`.
 *
 * Le SDK Browser rejette les caractères hors [\p{Ll}\p{Lo}0-9_:./-]
 * (minuscules uniquement) et les tags > 200 caractères
 * (cf. @datadog/browser-core/src/domain/tags.ts).
 *
 * Partagé entre le RUM (initDatadogRum.ts, tag `version`) et l'upload des
 * source maps (scripts/upload-datadog-sourcemaps.js, `--release-version`) :
 * les deux valeurs DOIVENT être identiques pour que DataDog rapproche les
 * erreurs des source maps. CommonJS (comme utils/env-config-generator.js) pour
 * être chargé par `require` (script Node) comme par `import` (webpack).
 */
const DATADOG_VERSION_MAX_LENGTH = 200 - "version:".length;

/**
 * @param {string} releaseVersion
 * @returns {string}
 */
const formatDatadogVersion = (releaseVersion) =>
  releaseVersion
    .toLowerCase()
    .replace(/[^\p{Ll}\p{Lo}0-9_:./-]/gu, "_")
    .slice(0, DATADOG_VERSION_MAX_LENGTH);

module.exports = { formatDatadogVersion };
